import '@fontsource/outfit/300.css'
import '@fontsource/outfit/400.css'
import '@fontsource/outfit/500.css'
import '@fontsource/outfit/700.css'
import '@fontsource/dm-sans/700.css'
import '@fontsource/montserrat/500-italic.css'
import '@fontsource/noto-sans-jp/400.css'
import '@fontsource/noto-sans-jp/500.css'
import '@fontsource/noto-sans-jp/700.css'
import '@fontsource/zen-kaku-gothic-new';
import '@fontsource-variable/roboto';
import './src/assets/sass/style.scss'

// 以下を追加
export const onClientEntry = () => {
  // クライアントサイドルーティングの初期化
  console.log("Client entry - initializing routing")
}

export const onRouteUpdate = ({ location, prevLocation }) => {
  // ルート更新時の処理
  // console.log("Route updated:", location.pathname + location.search)
  
  // ページネーション付きページの場合の特別処理
  if (location.pathname === '/search/' && location.search.includes('page=')) {
    // DOM更新を待ってから処理
    setTimeout(() => {
      const event = new CustomEvent('pageUpdated', { 
        detail: { pathname: location.pathname, search: location.search } 
      })
      window.dispatchEvent(event)
    }, 100)
  }
}

export const shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition
}) => {
  const { pathname, search } = location
  
  // searchページでページネーション時はトップにスクロール
  if (pathname === '/search/' && search.includes('page=')) {
    return [0, 0]
  }
  
  // その他のページネーションページ
  if (search.includes('page=')) {
    return [0, 0]
  }
  
  return true
}

export const onPreRouteUpdate = ({ location, prevLocation }) => {
  // ルート更新前の処理
  if (prevLocation && location.pathname === prevLocation.pathname && location.search !== prevLocation.search) {
    // 同じページ内でのクエリパラメータ変更の場合
    console.log("Query parameter change detected")
  }
}

